import $ from 'jquery';

export default class Nav {
    constructor() {
        if ($('.js-nav').length && Foundation.MediaQuery.is('medium down')) {
            $('.js-nav .menu-item-has-children > a').on('click', function(e) {
                const $this = $(this);

                e.preventDefault();

                $this.parent().toggleClass('is-active');
                $this.next().slideToggle();
            });
        };
    };
};
